module.exports = __webpack_public_path__ + "static/fonts/MontserratRegular.a8a11736.ttf";